module.exports = __webpack_public_path__ + "static/media/APOTHEO_LABO_PIERRE_FABRE_ORAL_CARE.7276f8f1.png";